"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { key: 7 };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CardRenderItemComponent = (0, vue_1.resolveComponent)("CardRenderItemComponent");
    const _component_CardRenderSymbolComponent = (0, vue_1.resolveComponent)("CardRenderSymbolComponent");
    const _component_CardProductionBoxComponent = (0, vue_1.resolveComponent)("CardProductionBoxComponent");
    const _component_CardRenderEffectBoxComponent = (0, vue_1.resolveComponent)("CardRenderEffectBoxComponent");
    const _component_CardRenderTileComponent = (0, vue_1.resolveComponent)("CardRenderTileComponent");
    const _component_CardDescription = (0, vue_1.resolveComponent)("CardDescription");
    const _component_CardRenderCorpBoxComponent = (0, vue_1.resolveComponent)("CardRenderCorpBoxComponent");
    return (_ctx.isItem(_ctx.componentData))
        ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderItemComponent, {
            key: 0,
            item: _ctx.componentData
        }, null, 8, ["item"]))
        : (_ctx.isSymbol(_ctx.componentData))
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderSymbolComponent, {
                key: 1,
                item: _ctx.componentData
            }, null, 8, ["item"]))
            : (_ctx.isProduction(_ctx.componentData))
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardProductionBoxComponent, {
                    key: 2,
                    rows: _ctx.componentData.rows
                }, null, 8, ["rows"]))
                : (_ctx.isEffect(_ctx.componentData))
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderEffectBoxComponent, {
                        key: 3,
                        effectData: _ctx.componentData
                    }, null, 8, ["effectData"]))
                    : (_ctx.isTile(_ctx.componentData))
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderTileComponent, {
                            key: 4,
                            item: _ctx.componentData
                        }, null, 8, ["item"]))
                        : (_ctx.isDescription(_ctx.componentData))
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardDescription, {
                                key: 5,
                                item: _ctx.componentData
                            }, null, 8, ["item"]))
                            : (_ctx.isCorpBox(_ctx.componentData))
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderCorpBoxComponent, {
                                    key: 6,
                                    rows: _ctx.componentData.rows,
                                    label: _ctx.corpBoxLabel()
                                }, null, 8, ["rows", "label"]))
                                : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, "n/a"));
}
